export default "__VITE_ASSET__PH3pzsio__"